<template>
    <div>
        <div>
        {{ $t("TRANSPORTER_PROFILE_E_INVOICE") }}
        <SwitchBtn
            v-model="switchButton"
            size="small"
            active-text="YES"
            inactive-text="NO"
            class="default-switch f-right"
            @change="changeEvent($event)">
        </SwitchBtn>
        </div>
    </div>
</template>
<script>

import { mapGetters } from 'vuex';

export default {
  name: 'einvoice',
  data() {
    return {
      switchButton: true,
    };
  },
  computed: {
    ...mapGetters({
      currentTransporter: 'app/currentTransporter',
    }),
  },
  async created() {
    this.switchButton = this.currentTransporter.e_invoice_verify;
  },
  methods: {
    async changeEvent(event) {
      const result = await this.$store.dispatch('app/updateEInvoiceConfig', { data: { flag: event } });
      if (result && result.data === 'Success') {
        this.$successMessage({ message: this.$getSuccess('UPDATE_SUCCESS') });
        await this.$store.dispatch('app/bootstrap', true);
        return true;
      }
      const message = (result && result.error) ? result.error : this.$getErr('500');
      this.$errorMessage({ message });
      return false;
    },
  },
};
</script>
